import { type PimProductV11 } from '@redteclab/api/clients/bully'

export const productAccessorIsPrescriptionProduct = (
  product: PimProductV11,
): boolean => {
  return product.flags?.prescription_medicine.active ?? false
}
